import { $admin } from "@/utils/https.js";

export function getWwwCount(params) {
    return $admin().get(`/api/cms/manage/www/count`, { params });
}

export function getBillCount(params) {
    return $admin().get(`/api/admin/manage/mall/handmade_bill/count`, { params });
}
